import { createFileRoute } from "@tanstack/react-router";
import { SEO } from "@/components/SEO.tsx";
import { HeroSection } from "@/components/home/HeroSection.tsx";
import { ServicesSection } from "@/components/home/ServicesSection.tsx";
import { EcosystemSection } from "@/components/home/EcosystemSection.tsx";
import { AlephSection } from "@/components/home/AlephSection.tsx";
import { FeaturesSection } from "@/components/home/FeaturesSection.tsx";
import { APISection } from "@/components/home/APISection.tsx";
import { ModelsSection } from "@/components/home/ModelsSection.tsx";
import { FAQSection } from "@/components/home/FAQSection.tsx";
import { FooterSection } from "@/components/FooterSection.tsx";

export const Route = createFileRoute("/")({
	component: Index,
});

function Index() {
	return (
		<main className="flex flex-col min-h-screen">
			<SEO
				title="Private AI, Unleashed"
				description="LibertAI is a decentralized, private AI platform powered by Aleph Cloud. Open-source models, confidential inference API, and AI agents — with privacy you can verify."
				path="/"
			/>
			<HeroSection />
			<ServicesSection />
			<EcosystemSection />
			<AlephSection />
			<FeaturesSection />
			<APISection />
			<ModelsSection />
			<FAQSection />
			<FooterSection />
		</main>
	);
}
